import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-evaluate_ic_complete",
  "use": "icon-evaluate_ic_complete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-evaluate_ic_complete\"><g fill=\"#1a1a1a\"><path d=\"m12 23c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zm0-20c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9 4.963 0 9-4.037 9-9 0-4.962-4.037-9-9-9z\" /><path d=\"m10.612 16.27c-.4 0-.777-.156-1.061-.439l-3.236-3.235c-.391-.391-.391-1.024 0-1.415s1.023-.391 1.414 0l2.882 2.882 5.656-5.657c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-6.01 6.01c-.28.283-.657.44-1.059.44.001 0 .001 0 0 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/evaluate_ic_complete.svg
// module id = 18w0
// module chunks = 87